// src/shared/store/redux/index.js
import { configureStore } from "@reduxjs/toolkit";

import { initLang } from "./translate-actions";
import { checkWindowSize } from "./responsive-action";
import { getGeneral, getHomeData } from "./uiData-actions";
import { checkLogin } from "./auth-actions";
import translateSlice from "./translate-slice";
import errorHandlingSlice from "./error-handling-slice";
import authSlice from "./auth-slice";
import responsiveSlice from "./responsive-slice";
import uiDataSlice from "./uiData-slice";
import entitiesSlice from "./entities-slice";
import schoolManagerSlice from "./schoolManager-slice";
// import assessmentSlice from "./assessment-slice";
// import coursesSlice from "./courses-slice";
// import eventsSlice from "./events-slice";
// import studyGroupSlice from "./studyGroup-slice";
// import messagesSlice from "./messages-slice";

const store = configureStore({
  reducer: {
    translate: translateSlice.reducer,
    errorHandling: errorHandlingSlice.reducer,
    auth: authSlice.reducer,
    responsive: responsiveSlice.reducer,
    uiData: uiDataSlice.reducer,
    entities: entitiesSlice.reducer,
    schoolManager: schoolManagerSlice.reducer,
    // studyGroup: studyGroupSlice.reducer,
    // messages: messagesSlice.reducer,
    // courses: coursesSlice.reducer,
    // assessment: assessmentSlice.reducer,
    // events: eventsSlice.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false
  })
});

export default store;
store.dispatch(initLang());
store.dispatch(checkWindowSize());
store.dispatch(checkLogin());
store.dispatch(getGeneral());
store.dispatch(getHomeData());